import React from 'react';
import { AlertModel, AlertType } from '../alerts';

export const ServiceWorkerAlertContext = React.createContext<AlertModel>({
  isShown: false,
  message: 'Error',
  type: AlertType.ERROR,
});
